import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";

import GettingStarted from "./components/GettingStarted";
import ConfirmationMessage from "./components/ConfirmationMessage";

import UserLogin from "./components/UserComponents/Login";
import UserRegister from "./components/UserComponents/Register";
import UserDashboard from "./components/UserComponents/Dashboard";
import UserApplicationForm from "./components/UserComponents/ApplicationForm";
import PreferredJobs from "./components/UserComponents/PreferredJobs";
import UniversityPosts from "./components/UserComponents/UniversityPosts";
import ProfilePage from "./components/UserComponents/ProfilePage";
import UserApplicationList from "./components/UserComponents/ApplicationList";
import UserEditProfile from "./components/UserComponents/EditProfile";
import Messaging from "./components/SocketIOComponents/Messaging";
import Discussions from "./components/UserComponents/Discussions";

import UniversityLogin from './components/UniversityComponents/Login';
import UniversityRegister from './components/UniversityComponents/Register';
import UniversityDashboard from './components/UniversityComponents/Dashboard';
import UniversityPostJob from './components/UniversityComponents/JobForm';
import UniversityViewRepostedJobs from './components/UniversityComponents/ViewPostedJobs';
import UniversityViewStudents from './components/UniversityComponents/ViewStudents';
import UniversityJobEdits from './components/UniversityComponents/JobEdits';
import ViewApplications from './components/UniversityComponents/ViewApplications';

import RecruiterLogin from "./components/RecruiterComponents/Login";
import RecruiterRegister from "./components/RecruiterComponents/Register";
import RecruiterDashboard from "./components/RecruiterComponents/Dashboard";
import RecruiterJobApplications from "./components/RecruiterComponents/ViewApplications";
import RecruiterJobForm from "./components/RecruiterComponents/JobForm";
import RecruiterEditJob from "./components/RecruiterComponents/JobEdit";

import NewsPage from "./components/SharedComponents/NewsAPI";

import { UserProvider } from "./Navbar/UserContext";
import Navbar from "./Navbar/Navbar";
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import NotificationToast from './components/NotificationComponents/NotificationToast';

import RecruiterCreateEvent from './components/Events/RecruiterCreateEvent';
import RecruiterMyEvents from './components/Events/RecruiterMyEvents';
import UniversityCreateEvent from './components/Events/UniverstyCreateEvents'; // Correct name
import UniversityMyEvents from './components/Events/UniversityMyEvents';
import UserEventList from './components/Events/UserEventList'; // Correct name
import UserEventDetails from './components/Events/UserEventDetails'; // Correct name

function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <NotificationProvider>
          <Router>
            <Navbar />
            <Routes>
              <Route path="/" element={<GettingStarted />} />

              {/* User Routes */}
              <Route path="/login" element={<UserLogin />} />
              <Route path="/register" element={<UserRegister />} />
              <Route path="/dashboard" element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
              <Route path="/dashboard/jobs/:id" element={<PrivateRoute><UserApplicationForm /></PrivateRoute>} />
              <Route path="/dashboard/jobs/:id/apply" element={<PrivateRoute><UserApplicationForm /></PrivateRoute>} />
              <Route path="/dashboard/university-posts" element={<PrivateRoute><UniversityPosts /></PrivateRoute>} />
              <Route path="/profile/applicationList" element={<PrivateRoute><UserApplicationList /></PrivateRoute>} />
              <Route path="/profile/messages" element={<PrivateRoute><Messaging /></PrivateRoute>} />
              <Route path="/discussions" element={<PrivateRoute><Discussions /></PrivateRoute>} />
              <Route path="/news" element={<PrivateRoute><NewsPage /></PrivateRoute>} />
              <Route path="/dashboard/preferredJobs" element={<PrivateRoute><PreferredJobs /></PrivateRoute>} />
              <Route path="/dashboard/jobs/:id/applied" element={<PrivateRoute><ConfirmationMessage /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
              <Route path="/profile/edit" element={<PrivateRoute><UserEditProfile /></PrivateRoute>} />
              <Route path="/dashboard/events" element={<PrivateRoute><UserEventList /></PrivateRoute>} />
              <Route path="/dashboard/events/:id" element={<PrivateRoute><UserEventDetails /></PrivateRoute>} />

              {/* University Partner Routes */}
              <Route path="/university/login" element={<UniversityLogin />} />
              <Route path="/university/register" element={<UniversityRegister />} />
              <Route path="/university/dashboard" element={<PrivateRoute><UniversityDashboard /></PrivateRoute>} />
              <Route path="/university/jobs/new" element={<PrivateRoute><UniversityPostJob /></PrivateRoute>} />
              <Route path="/university/jobs/reposted" element={<PrivateRoute><UniversityViewRepostedJobs /></PrivateRoute>} />
              <Route path="/university/jobs/:jobId/edit" element={<PrivateRoute><UniversityJobEdits /></PrivateRoute>} />
              <Route path="/university/students" element={<PrivateRoute><UniversityViewStudents /></PrivateRoute>} />
              <Route path="/university/jobs/:jobId/applications" element={<PrivateRoute><ViewApplications /></PrivateRoute>} />
              <Route path="/university/messages" element={<PrivateRoute><Messaging /></PrivateRoute>} />
              <Route path="/university/events" element={<PrivateRoute><UniversityMyEvents /></PrivateRoute>} />
              <Route path="/university/events/new" element={<PrivateRoute><UniversityCreateEvent /></PrivateRoute>} />

              {/* Recruiter Routes */}
              <Route path="/recruiter/login" element={<RecruiterLogin />} />
              <Route path="/recruiter/register" element={<RecruiterRegister />} />
              <Route path="/recruiter/dashboard" element={<PrivateRoute><RecruiterDashboard /></PrivateRoute>} />
              <Route path="/recruiter/jobs/:jobId/applications" element={<PrivateRoute><RecruiterJobApplications /></PrivateRoute>} />
              <Route path="/recruiter/jobs/new" element={<PrivateRoute><RecruiterJobForm /></PrivateRoute>} />
              <Route path="/recruiter/jobs/:jobId/edit" element={<PrivateRoute><RecruiterEditJob /></PrivateRoute>} />
              <Route path="/recruiter/messages" element={<PrivateRoute><Messaging /></PrivateRoute>} />
              <Route path="/recruiter/events" element={<PrivateRoute><RecruiterMyEvents /></PrivateRoute>} />
              <Route path="/recruiter/events/new" element={<PrivateRoute><RecruiterCreateEvent /></PrivateRoute>} />
            </Routes>
            <NotificationToast />
          </Router>
        </NotificationProvider>
      </UserProvider>
    </AuthProvider>
  );
}

export default App;
